/* eslint-disable react/no-array-index-key */
import Link from 'next/link';
import type { ListType } from 'src/service/creation';
import type { RepplResponse } from 'src/app/reppl/service';
import { useTranslation } from 'react-i18next';
import { useState, useEffect, useContext } from 'react';
import SvgArrowLeft from 'src/components/icons/arrow-left-v2-2x';
import SvgArrowRight from 'src/components/icons/arrow-right-v2';
import Creations from 'src/components/common/card/creations';
import { isDesktop } from 'react-device-detect';
import { UserContext, UserContextType } from 'src/contexts/UserContext';

interface FeatureEpisodesProps extends Pick<RepplResponse, 'reppl'> {
  episodes: ListType[];
  isLoaded: boolean;
  type?: string;
  isOwner: boolean;
}

export function FeatureEpisodes({
  reppl,
  episodes,
  isLoaded,
  type,
  isOwner,
}: FeatureEpisodesProps) {
  const { t } = useTranslation();
  const { user } = useContext(UserContext) as UserContextType;

  const idsTeamReppl = reppl?.team?.map((item) => {
    if (item?.role === '104') {
      return 0;
    }
    return item?.userID;
  });
  const isBelongTeam = idsTeamReppl?.includes(user?.id);

  const [translateX, setTranslateX] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);

  const benchmark = 1;
  const [rightLock, setRightLock] = useState(true);
  const [leftLock, setLeftLock] = useState(false);

  useEffect(() => {
    if (episodes.length > benchmark) {
      setLeftLock(false);
    }
  }, [episodes]);

  const offest = (direction) => {
    if (episodes.length <= benchmark) return;
    if (direction === 'right' && rightLock) return;
    if (direction === 'left' && leftLock) return;

    const offect = direction === 'left' ? -1 : 1;
    const x = 324 * offect + translateX;
    setTranslateX(x);
    const nextIndex = currentIndex - offect;
    let right = false;
    let left = false;
    if (nextIndex === 0) {
      right = true;
    } else if (nextIndex + benchmark >= episodes.length) {
      left = true;
    }
    setRightLock(right);
    setLeftLock(left);
    setCurrentIndex(nextIndex);
  };

  if (!isLoaded) {
    return (
      <div className="reppl-container-width animate-pulse mt-16">
        <div className="h-80 skeleton-line bg-white" />
      </div>
    );
  }

  if (isLoaded && !isBelongTeam && episodes.length === 0) {
    return null;
  }

  const fns = isOwner ? ['rmFeaturedFrontPage'] : [];

  return (
    <div className="px-4 reppl-container-width mt-16 px-2 md:px-auto ">
      <header className="text-gray-900 mb-6 flex justify-between items-center">
        <span className="font-medium md:text-xl">
          {type === 'official' ? t('FeaturedOfficial') : t('FeaturedOpen')}
        </span>
        <span>
          <Link href={`/reppl/${reppl.id}/${type}`} passHref>
            <a className="text-sm">{t('View all')}</a>
          </Link>
          {episodes.length > 4 && (
            <>
              <span
                className={`text-sm hidden md:inline cursor-pointer ml-5 mr-4 ${
                  rightLock ? 'text-gray-300' : ''
                }`}
              >
                <SvgArrowLeft
                  className="inline"
                  aria-hidden="true"
                  onClick={() => {
                    offest('right');
                  }}
                />
              </span>
              <span
                className={`text-sm hidden md:inline cursor-pointer ${
                  leftLock ? 'text-gray-300' : ''
                }`}
              >
                <SvgArrowRight
                  className="inline"
                  aria-hidden="true"
                  onClick={() => {
                    offest('left');
                  }}
                />
              </span>
            </>
          )}
        </span>
      </header>
      <div className="overflow-x-auto md:overflow-hidden pb-2">
        <div
          className={`flex ${isDesktop && 'explore-creations'} ${
            episodes.length < 4 ? 'section-empty-wrap' : ''
          }`}
          style={{ transform: `translateX(${translateX}px)` }}
        >
          <Creations
            className="mr-6 bg-white card-300"
            projectId={reppl.id}
            creationType="EPISODE"
            data={episodes}
            fns={fns}
          />

          {episodes.length < benchmark && isBelongTeam && (
            <div className="flex-1 section-empty rounded-md h-48 flex items-center">
              <p className="text-center flex-1">
                This section is not yet visible to your visitors until there are
                atleast 1 featured {type} episode in the RE:PPL.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
